import type { UploadFetch } from "@/upload";

export type CrsInfo = {
    name: string;
    area_of_use: {
        west: number;
        south: number;
        east: number;
        north: number;
    } | null;
    proj4_string: string | null;
};

const cache = new Map<string, Promise<CrsInfo | null>>();

const authenticatedFetch: UploadFetch = async (url, options) => {
    const { auth } = await import("@/state");
    return auth.fetch(url, options);
};

async function fetchCrsInfo(code: string, request: UploadFetch): Promise<CrsInfo | null> {
    const response = await request(`/api/crs/${code}`);
    if (response.status === 404) return null;
    if (!response.ok) throw new Error(`CRS lookup failed: ${response.status}`);
    return response.json() as Promise<CrsInfo>;
}

export function getCrsInfo(code: string, request: UploadFetch = authenticatedFetch): Promise<CrsInfo | null> {
    const cached = cache.get(code);
    if (cached) return cached;

    const result = fetchCrsInfo(code, request).catch((error) => {
        cache.delete(code);
        throw error;
    });
    cache.set(code, result);
    return result;
}
